import { FC, createElement, ReactHTML, CSSProperties } from 'react'
import cn from 'classnames'
import { Elevation, Sizes, Theme, ThemeStyle } from 'interfaces/component'
import { useFlexClassNames, useThemeClassNames } from 'hooks/useClassNames'

export type FlexGap = 'none' | 'spread' | Sizes
export type FlexPadding = 'none' | 'responsive' | 'large-responsive' | Sizes

export type FlexOptions = {
  horizontal?: boolean
  gap?: FlexGap
  padding?: FlexPadding
  elevation?: Elevation
  marginBottom?: Sizes
  verticallyCenter?: boolean
  horizontallyCenter?: boolean
  alignRight?: boolean
  shrinkHeight?: boolean
  shrinkWidth?: boolean
  fullWidth?: boolean
  responsive?: boolean
  rounded?: boolean
}

export type FlexProps =
  & FlexOptions
  & {
    style?: CSSProperties
    theme?: Theme
    themeStyle?: ThemeStyle
    component?: keyof ReactHTML
    className?: string
  }

const Flex: FC<FlexProps> = (props) => {
  const {
    component = 'div',
    children,
    className,
    themeStyle,
    theme,
    style,
    ...flexProps
  } = props

  const themeClasses = useThemeClassNames(theme, themeStyle)
  const flexClasses = useFlexClassNames(flexProps)
  const combinedClasses = cn(className, themeClasses, flexClasses)

  return createElement(component, { className: combinedClasses, style }, children)
}

export default Flex
